import Vue from 'vue'

import Vuetify from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
})

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1190cb',
        secondary: '#484848',
        accent: '#70bce0',
        error: '#e57373',

        // ...{
        //   primary: '#e2175b',
        //   secondary: '#484848',
        //   accent: '#ff80aa',
        //   error: '#e57373',
        // }
      },
    },
  },
})
